'use client'

import { ReactNode } from 'react'

import { stegaClean } from '@sanity/client/stega'

import { Link } from '@/app/components/Link'
import { TrackingLocation } from '@/app/utils/analytics'

interface PortableLinkProps {
  link: any
  children: ReactNode
  tracking: TrackingLocation
  className?: string
}

export default function PortableLink({ link, children, tracking, className }: PortableLinkProps) {
  if (!link) return <>{children}</>

  // Clean stega encoding
  const cleanLink = stegaClean(link)
  const href = cleanLink.href

  if (!href) {
    return <span className={className}>{children}</span>
  }

  // Convert to format expected by Link component
  const linkData = {
    _type: 'link' as const,
    href,
    openInNewTab: cleanLink.openInNewTab ?? null,
    label: typeof children === 'string' ? children : null,
    ariaLabel: null,
    external: null,
    mailto: null,
    tel: null,
    anchor: null,
    linkType: null,
    internalPage: null,
    internalPost: null,
  }

  return (
    <Link link={linkData} tracking={tracking} className={className}>
      {children}
    </Link>
  )
}
